import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=b5b70acc&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports